import React, { useState, useEffect } from "react";
import Layout from "../component/Layout";
import SubLayout from "../component/SubLayout";
import Header from "../component/Header";
import Container from "../component/Container";
import SmallLoader from "../component/SmallLoader";
import classes from "./SubscribePage.module.css";
import { useSelector } from "react-redux";

const TNCPage = () => {
  const { selectedLanguage } = useSelector((state) => state.languageSlice);
  console.log("Selected language ", selectedLanguage);
  return (
    <Layout>
      <SubLayout>
        <Header hide={true} />

        <Container>
          {selectedLanguage === 0 ? (
            <>
              <a href="/">
                <span className={classes.terms_conditions}>
                  {" "}
                  &lt;&lt; Go Back
                </span>
              </a>
              <p>
                <strong>MyFootball11 &ndash; privacy supplement</strong>
              </p>
              <p>
                This privacy supplement gives some general information around
                the processing conducted for MyFootball11 product, to provide
                further context to our&nbsp;
                <a href="https://www.vodacom.co.tz/privacy">
                  main privacy policy
                </a>
                . If you&rsquo;re using MyFootball11 together with another
                service, you should read the privacy information for the other
                service too.
              </p>
              <p>&nbsp;</p>
              <p>
                If you have any queries in any aspect of this privacy
                supplement, please call 100 or Customer Care Service desks and a
                member of our dedicated team will respond to you.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>MyFootball11</strong>
              </p>
              <p>
                <strong>MyFootball11</strong> is tailor-made for football lovers
                and offers operators a high-retention, high-engagement service
                with room for localization, monetization, and brand
                partnerships.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>Personal information we collect about you</strong>
              </p>
              <p>
                <strong>Information we collect about you</strong>
              </p>
              <p>&nbsp;</p>
              <p>The types of information we process includes;</p>
              <ul>
                <li>Your name and Mobile number</li>
                <li>
                  Your subscription type and payment channel ie. Airtime and/or
                  M-Pesa
                </li>
                <li>Customer care information through your contact with us,</li>
                <li>
                  Information about your usage of the App, such as how often you
                  use it or when you dismiss alerts; and
                </li>
              </ul>
              <p>
                We&rsquo;ll also get information about how you use our products
                and services, such as:
              </p>
              <ul>
                <li>
                  The level of service that you receive &ndash; for example,
                  delivery reports, delays or service faults and other events
                  that may affect our services;
                </li>
              </ul>
              <p>
                <strong>When we collect your personal information</strong>
              </p>
              <p>We collect your personal information when:</p>
              <ul>
                <li>You first subscribe to the service</li>
                <li>
                  You use the MyFootball11 service and any of its features
                </li>
                <li>You contact our customer care teams with a query.</li>
              </ul>
              <p>Vodacom will process your personal data based on:</p>
              <p>
                <strong>
                  The performance of your contract or to enter into the contract
                </strong>
                &nbsp;and to take action on your requests. For example,
                we&rsquo;ll need to process your network traffic data as part of
                making your device &ldquo;connected&rdquo; and we&rsquo;ll need
                to process Administrator's payment details for your monthly
                billing.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>Vodacom&rsquo;s legitimate business interests</strong>,
                for example, fraud prevention, maintaining the security of our
                network and services, direct marketing, and the improvement of
                our services. Whenever we rely on this lawful basis to process
                your data, we assess our business interests to make sure they do
                not override your rights. Additionally, in some cases you have
                the right to object to this processing. For more information,
                visit the 'Your rights' section of this policy.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>Compliance with a mandatory legal obligation</strong>,
                including for example accounting and tax requirements, which are
                subject to strict internal policies (such as retention periods),
                procedures, and your right to restrict usage of your data, which
                control the scope of legal assistance to be provided.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>Consent you provide</strong>&nbsp;where Vodacom does not
                rely on another legal basis. Consent may be withdrawn at any
                time. When you give your consent, you will be given details on
                how to change your mind or visit the 'Your rights' section of
                this policy for more information.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>How we use your personal information</strong>
              </p>
              <p>
                <strong>To provide you with your service</strong>
              </p>
              <p>
                We use your information for service provision and to fulfil any
                purchases you have made:
              </p>
              <ul>
                <li>
                  to help us identify you and any accounts you hold with us;
                </li>
                <li>to provide you access to the service</li>
                <li>billing and customer care;</li>
                <li>
                  to notify you of any changes to the services that may affect
                  you; and
                </li>
                <li>identity verification.</li>
              </ul>
              <p>
                <strong>Marketing and profiling</strong>
              </p>
              <p>
                If you are opted into marketing and have given us permission to
                use your data to tailor these communications, we&rsquo;ll use
                your interactions with this portal to inform the sorts of
                marketing we should be sending you so that it&rsquo;s the most
                relevant for you. To opt out of Marketing messages or profiling:
              </p>
              <p>
                If you no longer want to receive marketing messages from
                Vodacom, you can elect to opt out of all marketing
                communications or only selected methods (email, messaging, phone
                or post).
              </p>
              <p>There are various ways to opt out:</p>
              <ul>
                <li>Contact our customer care team by dialing 100;</li>
                <li>
                  All our marketing messages come with an
                  &ldquo;unsubscribe&rdquo; link which you can click to
                  unsubscribe;
                </li>
                <li>
                  Tell the adviser you no longer want to be marketed to, if you
                  receive an outbound marketing call;
                </li>
                <li>
                  Email{" "}
                  <a href="mailto:customercare@vodacom.co.tz">
                    customercare@vodacom.co.tz
                  </a>{" "}
                  for guidance.
                </li>
                <li>
                  Opting out does not mean that you won&rsquo;t any longer
                  receive service-related messages, such as messages telling you
                  about your order status or when our Terms and Conditions
                  change. You will still continue to receive those (unless we
                  have indicated otherwise). You may also receive marketing via
                  push notifications if you have not turned them off via your
                  App settings.
                </li>
              </ul>
              <p>
                <strong>Service improvement</strong>
              </p>
              <p>
                We collect anonymous, de-identified or aggregate information in
                order to improve the service we offer to everyone. None of these
                analytics are linked back to you in any way.
              </p>
              <p>
                To protect our networks and manage the volumes of calls, texts
                and other uses of our networks. For example, we identify peak
                periods of use so we can try and ensure the networks can handle
                the volume at those times; and
              </p>
              <p>
                To understand how you use our networks, products and services.
                That way we can seek to review, develop and improve these,
                develop more interesting and relevant products and services, as
                well as personalizing our products and services.
              </p>
              <p>
                <strong>How we share your personal information</strong>
              </p>
              <p>Where applicable, we share information about you with:</p>
              <ul>
                <li>Companies in the Vodafone Group</li>
                <li>
                  Partners, suppliers or agents involved in delivering the
                  products and services you&rsquo;ve ordered or used
                </li>
                <li>
                  Companies who are engaged to perform services for, or on
                  behalf of, Vodacom Tanzania Plc, or Vodacom Group or Vodafone
                  Group
                </li>
                <li>
                  Credit reference, fraud-prevention or business-scoring
                  agencies, or other credit scoring agencies
                </li>
                <li>
                  Debt collection agencies or other debt-recovery organizations
                </li>
                <li>
                  Law enforcement agencies, government bodies, regulatory
                  organizations, courts or other public authorities if we have
                  to, or are authorized to by law
                </li>
                <li>
                  A third party or body where such disclosure is required to
                  satisfy any applicable law, or other legal or regulatory
                  requirement
                </li>
                <li>
                  Third parties for joint promotions with that third party.
                  They&rsquo;ll be responsible for their own compliance with
                  applicable privacy laws
                </li>
              </ul>
              <p>
                <strong>International data transfers</strong>
              </p>
              <p>
                We do not make international transfers of personal data outside
                Tanzania;&nbsp;All data is stored on a platform managed by
                Vodacom.
              </p>
              <p>
                <strong>How long we keep your personal information for</strong>
              </p>
              <p>
                <strong>
                  To provide the service, billing and for authentication
                  purposes&nbsp;
                </strong>
                <br /> Personal data detailed in previous sections will be kept
                for the time necessary to provide the service to the
                user.&nbsp;&nbsp;&nbsp;
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>Providing the service&nbsp;</strong>
              </p>
              <p>
                The data related to the operation data of the service or the
                network history described above will be kept for 90 days and
                then will be anonymized or deleted.&nbsp;Personal data related
                to the user and his network will be kept for the time in which
                the user has activated the service.&nbsp;They will be removed
                after 12 months after the user unsubscribes from the service.
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>
                <strong>Diagnostics services</strong>
              </p>
              <p>
                We will collect data in order to enhance your services. The
                types of data sets and the retention related to these data types
                can be seen in &ldquo;Personal Information we collect about
                you&rdquo; section.
              </p>
              <p>
                For information about other data retention with Vodacom, please
                refer to our&nbsp;
                <a href="https://vodacom.co.tz/public/assets/files/Vodacom%20Tz-%20%20Customer%20Privacy%20Statement-retention-schedule.pdf">
                  retention schedule
                </a>
              </p>
              <p>
                <strong>Keeping your personal information secure</strong>
              </p>
              <p>
                We have specialized security teams who constantly review and
                improve our measures to protect your personal information from
                unauthorized access, accidental loss, disclosure or destruction.
              </p>
              <p>
                Communications over the internet (such as emails) aren&rsquo;t
                secure unless they&rsquo;ve been encrypted. Your communications
                may go through a number of countries before being delivered, as
                this is the nature of the internet.
              </p>
              <p>
                We cannot accept responsibility for any unauthorized access or
                loss of personal information that is beyond our control.
              </p>
              <p>
                We&rsquo;ll never ask for your secure personal or account
                information by an unsolicited means of communication.
                You&rsquo;re responsible for keeping your personal and account
                information secure and not sharing it with others.
              </p>
              <p>
                Our website may provide links to third-party websites. We cannot
                be responsible for the security and content of such third-party
                websites. So make sure you read that company&rsquo;s privacy and
                cookies policies before using or putting your personal
                information on their site.
              </p>
              <p>
                The same applies to any third-party websites or content you
                connect to using our products and services.
              </p>
              <p>
                You may choose to disclose your information in certain ways such
                as social plug-ins (including those offered by Google, Facebook,
                Twitter and Pinterest) or using third-party services that allow
                you to post reviews or other information publicly, and a third
                party could use that information.
              </p>
              <p>
                Social plug-ins and social applications are operated by the
                social network themselves and are subject to their own terms of
                use and privacy and cookies policies. You should make sure
                you&rsquo;re familiar with these.
              </p>
              <p>
                <strong>Your rights</strong>
              </p>
              <p>
                Below we set out details on how you can exercise your
                rights.&nbsp; If you have a question or cannot find the answer,
                please visit our or visit our Vodacom shops or Customer Care
                Service desks for more information or call 100.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>Right to rectify personal data </strong>
              </p>
              <p>
                You have the right to have information held about you corrected
                if it is not accurate. If what we hold on you needs updating, or
                you think it may be inaccurate, you can visit our Vodacom shops
                or Customer Care Service desks to update it.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>Right to access personal data</strong>
              </p>
              <p>
                You have the right to make a request for a copy of the personal
                data that Vodacom holds about you. To make this request as an
                individual or an authorised third party, visit our Vodacom shops
                or Customer Care Service desks for more information on how to do
                this.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>
                  Right to prevent processing likely to affect you or to another
                  person{" "}
                </strong>
              </p>
              <p>
                You are entitled to require Vodacom to suspend or not to begin,
                processing of any of your personal data, if the processing of
                such personal data is likely to cause substantial damage to you
                or to another person. You can visit our Vodacom shops or
                Customer Care Service desks you can email us at{" "}
                <a href="mailto:customercare@vodacom.co.tz">
                  customercare@vodacom.co.tz
                </a>{" "}
                to discuss your rights. In certain circumstances, you will have
                the right to ask us to restrict the processing
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>
                  Right to prevent processing of personal data for direct
                  marketing
                </strong>
              </p>
              <p>
                You have the right, in certain circumstances, to object to
                Vodacom processing your personal information for direct
                marketing. If you no longer want to receive marketing messages
                from Vodacom, you can elect to opt out of all marketing
                communications or only selected methods through CPM on Myvodacom
                App and Vodacom website, email, SMS, MMS, calling to customer
                care centre or post).&nbsp;
              </p>
              <p>
                For more information or to exercise this right, please call 100
                or visit our Vodacom shops or Customer Care Service desks.
              </p>
              <p>
                <strong>&nbsp;</strong>
              </p>
              <p>
                <strong>Rights in relation to automated decision making</strong>
              </p>
              <p>
                You have the right to require Vodacom to ensure that any
                decision taken by or on behalf of you which significantly
                affects you shall not base solely on the processing by automatic
                means. please let us know and we will review your request
              </p>
              <p>
                <strong>&nbsp;</strong>
              </p>
              <p>
                <strong>Right to erasure, block or destroy</strong>
              </p>
              <p>
                In some circumstances, such as where we no longer have a
                justifiable reason to continue to process your data or if not
                required by the law to retain such data, you can request we
                delete, block or destroy it.
              </p>
              <p>
                <strong>&nbsp;</strong>
              </p>
              <p>
                <strong>Right to compensation</strong> <strong>&nbsp; </strong>
              </p>
              <p>
                If your rights have been infringed by Vodacom by reason of any
                contravention of any of the requirements of the Personal Data
                Protection Act, you are entitled to compensation from Vodacom
                for that damage.
              </p>
              <p>
                <strong>&nbsp;</strong>
              </p>
              <p>
                <strong>How to lodge a complaint</strong>
              </p>
              <p>
                If you have a complaint, you can contact us on the details
                provided. We&rsquo;ll do our best to help but if you&rsquo;re
                still unhappy, you can contact the Personal Data Protection
                Commission.
              </p>
            </>
          ) : (
            <>
              <a href="/">
                <span className={classes.terms_conditions}>
                  {" "}
                  &lt;&lt; Rudi Nyuma
                </span>
              </a>
              <p>
                <strong>MyFootball11 - nyongeza ya faragha</strong>
              </p>
              <p>
                Kijalizo hiki cha faragha kinatoa taarifa za jumla kuhusu
                usindikaji unaofanywa kwa bidhaa ya MyFootball11, ili kutoa
                muktadha zaidi kwa{" "}
                <a href="https://www.vodacom.co.tz/privacy">
                  sera yetu kuu ya faragha{" "}
                </a>
                . Ikiwa unatumia MyFootball11 pamoja na huduma nyingine,
                unapaswa kusoma taarifa za faragha kwa huduma nyingine pia.
              </p>
              <p>
                Ikiwa una maswali yoyote kuhusu kipengele chochote cha nyongeza
                hii ya faragha, tafadhali piga simu 100 au dawati la Huduma kwa
                Wateja na mshiriki wa timu yetu iliyojitolea atakujibu.
              </p>
              <p>
                <strong>MyFootball11</strong>
              </p>
              <p>
                <strong>MyFootball11 </strong>imeundwa mahususi kwa wapenzi wa
                mpira wa miguu na huwapa waendeshaji huduma ya kuhifadhi
                wachezaji wengi na yenye ushiriki mkubwa pamoja na nafasi ya
                ujanibishaji, uchumaji mapato, na ushirikiano wa chapa.
              </p>
              <p>
                <strong>Taarifa binafsi tunazokusanya kukuhusu</strong>
              </p>
              <p>
                <strong>Taarifa tunazokusanya kukuhusu</strong>
              </p>
              <p>Aina za taarifa tunazoshughulikia ni pamoja na;</p>
              <ul>
                <li>Jina lako na nambari ya simu</li>
                <li>
                  Aina ya usajili wako na njia ya malipo yaani . Muda wa
                  maongezi na/au M- Pesa
                </li>
                <li>
                  Taarifa za huduma kwa wateja kupitia mawasiliano yako nasi,
                </li>
                <li>
                  Taarifa kuhusu matumizi yako ya Programu, kama vile mara ngapi
                  unaitumia au unapoondoa arifa; na
                </li>
              </ul>
              <p>
                Pia tutapata taarifa kuhusu jinsi unavyotumia bidhaa na huduma
                zetu, kama vile:
              </p>
              <ul>
                <li>
                  Kiwango cha huduma unachopokea - kwa mfano, ripoti za
                  uwasilishaji, ucheleweshaji au hitilafu za huduma na matukio
                  mengine ambayo yanaweza kuathiri huduma zetu;
                </li>
              </ul>
              <p>
                <strong>Tunapokusanya taarifa zako binafsi</strong>
              </p>
              <p>Tunakusanya taarifa zako binafsi wakati:</p>
              <ul>
                <li>Kwanza unajisajili kwa huduma</li>
                <li>
                  Unatumia huduma ya MyFootball11 na vipengele vyake vyovyote
                </li>
                <li>Wasiliana na timu zetu za huduma kwa wateja kwa swali.</li>
              </ul>
              <p>Vodacom itashughulikia data yako binafsi kulingana na:</p>
              <p>
                <strong>
                  Utekelezaji wa mkataba wako au kuingia katika mkataba{" "}
                </strong>
                na kuchukua hatua kuhusu maombi yako. Kwa mfano, tutahitaji
                kuchakata data ya trafiki ya mtandao wako kama sehemu ya kufanya
                kifaa chako "kiunganishwe" na tutahitaji kuchakata maelezo ya
                malipo ya Msimamizi kwa ajili ya bili yako ya kila mwezi.
              </p>
              <p>
                <strong>Maslahi halali ya biashara ya Vodacom </strong>, kwa
                mfano, kuzuia ulaghai, kudumisha usalama wa mtandao na huduma
                zetu, uuzaji wa moja kwa moja, na uboreshaji wa huduma zetu.
                Wakati wowote tunapotegemea msingi huu halali kusindika data
                yako, tunatathmini maslahi yetu ya biashara ili kuhakikisha
                hayazidi haki zako. Zaidi ya hayo, katika baadhi ya matukio una
                haki ya kupinga usindikaji huu. Kwa maelezo zaidi, tembelea
                sehemu ya 'Haki zako' ya sera hii.
              </p>
              <p>
                <strong>Kuzingatia wajibu wa kisheria wa lazima </strong>, ikiwa
                ni pamoja na kwa mfano mahitaji ya uhasibu na kodi, ambayo
                yanategemea sera kali za ndani (kama vile vipindi vya
                kuhifadhi), taratibu, na haki yako ya kuzuia matumizi ya data
                yako, ambayo hudhibiti wigo wa usaidizi wa kisheria unaotolewa.
              </p>
              <p>
                <strong>Ridhaa unayotoa </strong>pale ambapo Vodacom haitegemei
                msingi mwingine wa kisheria. Ridhaa inaweza kuondolewa wakati
                wowote. Utakapotoa ridhaa yako, utapewa maelezo ya jinsi ya
                kubadilisha mawazo yako au kutembelea sehemu ya 'Haki zako' ya
                sera hii kwa maelezo zaidi.
              </p>
              <p>
                <strong>Jinsi tunavyotumia taarifa zako binafsi</strong>
              </p>
              <p>
                <strong>Ili kukupa huduma yako</strong>
              </p>
              <p>
                Tunatumia taarifa zako kwa ajili ya utoaji wa huduma na kutimiza
                ununuzi wowote uliofanya:
              </p>
              <ul>
                <li>
                  kutusaidia kukutambua wewe na akaunti yoyote unayo nasi;
                </li>
                <li>ili kukupa ufikiaji wa huduma</li>
                <li>bili na huduma kwa wateja;</li>
                <li>
                  kukujulisha kuhusu mabadiliko yoyote kwenye huduma ambayo
                  yanaweza kukuathiri; na
                </li>
                <li>uthibitishaji wa utambulisho.</li>
              </ul>
              <p>
                <strong>Masoko na uundaji wa wasifu</strong>
              </p>
              <p>
                Ukichaguliwa kujiunga na uuzaji na umetupa ruhusa ya kutumia
                data yako ili kurekebisha mawasiliano haya, tutatumia
                mwingiliano wako na lango hili ili kukufahamisha aina za uuzaji
                tunaopaswa kukutumia ili uwe unaofaa zaidi kwako. Ili kujiondoa
                kwenye ujumbe wa Masoko au uundaji wa wasifu:
              </p>
              <p>
                Ikiwa hutaki tena kupokea jumbe za masoko kutoka Vodacom,
                unaweza kuchagua kujiondoa kwenye mawasiliano yote ya masoko au
                njia zilizochaguliwa pekee (barua pepe, ujumbe mfupi, simu au
                chapisho).
              </p>
              <p>Kuna njia mbalimbali za kujiondoa:</p>
              <ul>
                <li>
                  Wasiliana na timu yetu ya huduma kwa wateja kwa kupiga 100;
                </li>
                <li>
                  Ujumbe wetu wote wa uuzaji huja na kiungo cha "jiondoe"
                  ambacho unaweza kubofya ili kujiondoa;
                </li>
                <li>
                  Mwambie mshauri kwamba hutaki tena kuuzwa naye, ukipokea simu
                  ya uuzaji inayotoka nje;
                </li>
                <li>
                  Tuma barua pepe{" "}
                  <a href="mailto:customercare@vodacom.co.tz">
                    kwa customercare@vodacom.co.tz{" "}
                  </a>
                  kwa mwongozo.
                </li>
                <li>
                  Kujiondoa hakumaanishi kwamba hutapokea tena jumbe
                  zinazohusiana na huduma, kama vile jumbe zinazokuambia kuhusu
                  hali ya agizo lako au wakati Sheria na Masharti yetu
                  yatabadilika. Bado utaendelea kupokea hizo (isipokuwa kama
                  tumeonyesha vinginevyo). Unaweza pia kupokea matangazo kupitia
                  arifa za kusukuma ikiwa hujazizima kupitia mipangilio ya
                  Programu yako.
                </li>
              </ul>
              <p>
                <strong>Uboreshaji wa huduma</strong>
              </p>
              <p>
                Tunakusanya taarifa zisizojulikana, zisizotambulika au
                zilizokusanywa ili kuboresha huduma tunayotoa kwa kila mtu.
                Hakuna hata moja ya uchanganuzi huu iliyounganishwa na wewe kwa
                njia yoyote ile.
              </p>
              <p>
                Ili kulinda mitandao yetu na kudhibiti ujazo wa simu, ujumbe
                mfupi na matumizi mengine ya mitandao yetu. Kwa mfano,
                tunatambua vipindi vya juu vya matumizi ili tuweze kujaribu
                kuhakikisha mitandao inaweza kushughulikia ujazo wakati huo; na
              </p>
              <p>
                Ili kuelewa jinsi unavyotumia mitandao, bidhaa na huduma zetu.
                Kwa njia hiyo tunaweza kutafuta kupitia, kuendeleza na kuboresha
                hizi, kutengeneza bidhaa na huduma zinazovutia zaidi na
                zinazofaa, pamoja na kubinafsisha bidhaa na huduma zetu.
              </p>
              <p>
                <strong>Jinsi tunavyoshiriki taarifa zako binafsi</strong>
              </p>
              <p>Inapohitajika, tunashiriki taarifa kukuhusu na:</p>
              <ul>
                <li>Makampuni katika Kundi la Vodafone</li>
                <li>
                  Washirika, wasambazaji au mawakala wanaohusika katika kutoa
                  bidhaa na huduma ulizoagiza au kutumia
                </li>
                <li>
                  Makampuni ambayo yamejitolea kutoa huduma kwa, au kwa niaba
                  ya, Vodacom Tanzania Plc, au Vodacom Group au Vodafone Group
                </li>
                <li>
                  Mawakala wa marejeleo ya mikopo, kuzuia ulaghai au alama za
                  biashara, au mashirika mengine ya alama za mikopo
                </li>
                <li>
                  Mashirika ya ukusanyaji wa madeni au mashirika mengine ya
                  kurejesha madeni
                </li>
                <li>
                  Mashirika ya kutekeleza sheria, vyombo vya serikali, mashirika
                  ya udhibiti, mahakama au mamlaka mengine ya umma ikiwa ni
                  lazima, au tumeidhinishwa na sheria.
                </li>
                <li>
                  Mtu wa tatu au chombo ambapo ufichuzi huo unahitajika ili
                  kukidhi sheria yoyote inayotumika, au sharti lingine la
                  kisheria au la udhibiti
                </li>
                <li>
                  Wahusika wengine kwa ajili ya matangazo ya pamoja na mtu huyo
                  wa tatu. Watakuwa na jukumu la kufuata sheria husika za
                  faragha.
                </li>
              </ul>
              <p>
                <strong>Uhamisho wa data wa kimataifa</strong>
              </p>
              <p>
                Hatufanyi uhamisho wa kimataifa wa data binafsi nje ya Tanzania;
                Data zote huhifadhiwa kwenye mfumo unaosimamiwa na Vodacom.
              </p>
              <p>
                <strong>Tutahifadhi taarifa zako binafsi kwa muda gani</strong>
              </p>
              <p>
                <strong>
                  Ili kutoa huduma, bili na kwa madhumuni ya uthibitishaji,{" "}
                </strong>
                <br /> data binafsi iliyoelezwa katika sehemu zilizopita
                itahifadhiwa kwa muda unaohitajika ili kutoa huduma kwa
                mtumiaji.
              </p>
              <p>
                <strong>Kutoa huduma</strong>
              </p>
              <p>
                Data inayohusiana na data ya uendeshaji wa huduma au historia ya
                mtandao iliyoelezwa hapo juu itahifadhiwa kwa siku 90 na kisha
                itafichwa au kufutwa. Data binafsi inayohusiana na mtumiaji na
                mtandao wake itahifadhiwa kwa muda ambao mtumiaji amewasha
                huduma. Itaondolewa baada ya miezi 12 baada ya mtumiaji
                kujiondoa kwenye huduma.
              </p>
              <p>
                <strong>Huduma za uchunguzi</strong>
              </p>
              <p>
                Tutakusanya data ili kuboresha huduma zako. Aina za seti za data
                na uhifadhi unaohusiana na aina hizi za data unaweza kuonekana
                katika sehemu ya "Taarifa Binafsi tunazokusanya kukuhusu".
              </p>
              <p>
                Kwa maelezo kuhusu uhifadhi mwingine wa data na Vodacom,
                tafadhali rejelea{" "}
                <a href="https://vodacom.co.tz/public/assets/files/Vodacom%20Tz-%20%20Customer%20Privacy%20Statement-retention-schedule.pdf">
                  ratiba yetu ya uhifadhi.
                </a>
              </p>
              <p>
                <strong>Kuweka taarifa zako binafsi salama</strong>
              </p>
              <p>
                Tuna timu maalum za usalama ambazo hupitia na kuboresha hatua
                zetu za kulinda taarifa zako binafsi kutokana na ufikiaji
                usioidhinishwa, upotevu wa bahati mbaya, ufichuzi au uharibifu.
              </p>
              <p>
                Mawasiliano kupitia intaneti (kama vile barua pepe) si salama
                isipokuwa yamesimbwa kwa njia fiche. Mawasiliano yako yanaweza
                kupitia nchi kadhaa kabla ya kuwasilishwa, kwani hii ndiyo asili
                ya intaneti.
              </p>
              <p>
                Hatuwezi kukubali jukumu la ufikiaji wowote usioidhinishwa au
                upotevu wa taarifa binafsi ambao uko nje ya uwezo wetu.
              </p>
              <p>
                Hatutawahi kuomba taarifa zako za kibinafsi au za akaunti yako
                salama kwa njia isiyoombwa ya mawasiliano. Unawajibika kwa
                kuweka taarifa zako za kibinafsi na za akaunti yako salama na
                kutozishiriki na wengine.
              </p>
              <p>
                Tovuti yetu inaweza kutoa viungo vya tovuti za wahusika wengine.
                Hatuwezi kuwajibika kwa usalama na maudhui ya tovuti hizo za
                wahusika wengine. Kwa hivyo hakikisha unasoma sera za faragha na
                vidakuzi vya kampuni hiyo kabla ya kutumia au kuweka taarifa
                zako binafsi kwenye tovuti yao.
              </p>
              <p>
                Vivyo hivyo kwa tovuti au maudhui yoyote ya watu wengine
                unayounganisha nayo kwa kutumia bidhaa na huduma zetu.
              </p>
              <p>
                Unaweza kuchagua kufichua taarifa zako kwa njia fulani kama vile
                programu-jalizi za kijamii (ikiwa ni pamoja na zile zinazotolewa
                na Google, Facebook, Twitter na Pinterest) au kutumia huduma za
                wahusika wengine zinazokuruhusu kuchapisha maoni au taarifa
                nyingine hadharani, na mtu wa tatu anaweza kutumia taarifa hiyo.
              </p>
              <p>
                Programu-jalizi za kijamii na programu za kijamii zinaendeshwa
                na mtandao wa kijamii wenyewe na zinategemea masharti yao ya
                matumizi na sera za faragha na vidakuzi. Unapaswa kuhakikisha
                unazifahamu.
              </p>
              <p>
                <strong>Haki zako</strong>
              </p>
              <p>
                Hapa chini tumeelezea maelezo kuhusu jinsi unavyoweza kutumia
                haki zako. Ikiwa una swali au huwezi kupata jibu, tafadhali
                tembelea au tembelea maduka yetu ya Vodacom au dawati la Huduma
                kwa Wateja kwa maelezo zaidi au piga simu 100.
              </p>
              <p>
                <strong>Haki ya kurekebisha data binafsi</strong>
              </p>
              <p>
                Una haki ya kufanyiwa marekebisho ya taarifa kukuhusu ikiwa si
                sahihi. Ikiwa tunachokushikilia kinahitaji kusasishwa, au
                unafikiri kinaweza kuwa si sahihi, unaweza kutembelea maduka
                yetu ya Vodacom au dawati la Huduma kwa Wateja ili kusasisha.
              </p>
              <p>
                <strong>Haki ya kufikia data binafsi</strong>
              </p>
              <p>
                Una haki ya kuomba nakala ya data binafsi ambayo Vodacom
                inashikilia kukuhusu. Ili kuomba ombi hili kama mtu binafsi au
                mtu mwingine aliyeidhinishwa , tembelea maduka yetu ya Vodacom
                au dawati la Huduma kwa Wateja kwa maelezo zaidi kuhusu jinsi ya
                kufanya hivi.
              </p>
              <p>
                <strong>
                  Haki ya kuzuia usindikaji unaoweza kukuathiri wewe au mtu
                  mwingine
                </strong>
              </p>
              <p>
                Una haki ya kuitaka Vodacom isimamishe au iache kusindika data
                yako yoyote ya kibinafsi, ikiwa usindikaji wa data hiyo ya
                kibinafsi unaweza kusababisha uharibifu mkubwa kwako au kwa mtu
                mwingine. Unaweza kutembelea maduka yetu ya Vodacom au dawati la
                Huduma kwa Wateja au unaweza kututumia barua pepe kwa{" "}
                <a href="mailto:customercare@vodacom.co.tz">
                  customercare@vodacom.co.tz{" "}
                </a>
                ili kujadili haki zako. Katika hali fulani, utakuwa na haki ya
                kutuomba tuzuie usindikaji.
              </p>
              <p>
                <strong>
                  Haki ya kuzuia usindikaji wa data binafsi kwa ajili ya uuzaji
                  wa moja kwa moja
                </strong>
              </p>
              <p>
                Una haki, katika hali fulani, kupinga Vodacom kusindika taarifa
                zako binafsi kwa ajili ya uuzaji wa moja kwa moja. Ikiwa hutaki
                tena kupokea jumbe za uuzaji kutoka Vodacom, unaweza kuchagua
                kujiondoa kwenye mawasiliano yote ya uuzaji au njia
                zilizochaguliwa pekee kupitia CPM kwenye Programu ya Myvodacom
                na tovuti ya Vodacom, barua pepe, SMS, MMS, kupiga simu kwa
                kituo cha huduma kwa wateja au posta).
              </p>
              <p>
                Kwa maelezo zaidi au kutumia haki hii, tafadhali piga simu 100
                au tembelea maduka yetu ya Vodacom au dawati la Huduma kwa
                Wateja.
              </p>
              <p>
                <strong>
                  Haki zinazohusiana na kufanya maamuzi kiotomatiki
                </strong>
              </p>
              <p>
                Una haki ya kuitaka Vodacom kuhakikisha kwamba uamuzi wowote
                unaofanywa na au kwa niaba yako unaokuathiri pakubwa
                hautategemea tu usindikaji kwa njia za kiotomatiki. tafadhali
                tujulishe nasi tutapitia ombi lako
              </p>
              <p>
                <strong>Haki ya kufuta, kuzuia au kuharibu</strong>
              </p>
              <p>
                Katika baadhi ya hali, kama vile ambapo hatuna sababu ya msingi
                ya kuendelea kuchakata data yako au ikiwa haihitajiki kisheria
                kuhifadhi data kama hiyo, unaweza kuomba tuifute, tuizuie au
                kuiharibu.
              </p>
              <p>
                <strong>Haki ya fidia</strong>
              </p>
              <p>
                Ikiwa haki zako zimevunjwa na Vodacom kwa sababu ya ukiukaji
                wowote wa mahitaji yoyote ya Sheria ya Ulinzi wa Data Binafsi,
                una haki ya kulipwa fidia kutoka Vodacom kwa uharibifu huo.
              </p>
              <p>
                <strong>Jinsi ya kuwasilisha malalamiko</strong>
              </p>
              <p>
                Ukiwa na malalamiko, unaweza kuwasiliana nasi kwa maelezo
                yaliyotolewa. Tutafanya tuwezavyo kukusaidia lakini ikiwa bado
                hujaridhika, unaweza kuwasiliana na Tume ya Ulinzi wa Data
                Binafsi.
              </p>
            </>
          )}
        </Container>
      </SubLayout>
    </Layout>
  );
};

export default TNCPage;
